export default "__VITE_PUBLIC_ASSET__114acca4__"